<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
     
        <b-button block v-b-toggle.term-section-8
          class="text-left fw-500 d-flex align-items-center justify-content-between">
              <div>
                  <span class="box-numbering">08</span>
                  <span>Fraud Prevention and Security</span>    
              </div>
              <span 
                  class="toggle-icon" 
                  :class="{ active: isOpen }"
              >
                  <span class="plus">+</span>
                  <span class="cross">×</span>
              </span> 
        </b-button>

      </b-card-header>
      <b-collapse
        id="term-section-8"
        visible
        accordion="my-accordion"
        role="tabpanel"
        @show="isOpen = true"
        @hide="isOpen = false"
      >
        <b-card-body>
          <p class="text-justify">
            You are responsible for protecting your card, account details, and
            any personal identification numbers (PINs). Do not share your PIN
            with others.
          </p>
          <p class="text-justify">
            If your card is lost, stolen, or used without your permission, you
            must notify us immediately at
            <a href="mailto:support@oripay.us" class="fz-16">support@oripay.us</a>
          </p>
          <p class="text-justify">
            We will not be liable for any losses arising from unauthorized use
            of your card if you fail to notify us promptly.
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "term-5",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isOpen: true
    };
  },
  props:['companyName']
};
</script>
